/*
 * GS colour swatches on product cards (T-shirts).
 * Tapping a swatch never adds to cart: it swaps the card image to that colour,
 * points the card links at that colour's variant, and remembers the colour so
 * Quick Add opens on it.
 */
(function () {
  if (window.GSCardSwatches) return;

  function cleanSrcset(value) {
    return (value || '').replace(/\s+/g, ' ').replace(/,\s*$/, '').trim();
  }

  function updateLinks(cardWrapper, variantId) {
    if (!variantId) return;
    cardWrapper.querySelectorAll('a[href]').forEach(function (link) {
      var id = link.id || '';
      if (id.indexOf('CardLink-') !== 0 && id.indexOf('StandardCardNoMediaLink-') !== 0) return;
      try {
        var url = new URL(link.getAttribute('href'), window.location.origin);
        url.searchParams.set('variant', variantId);
        link.setAttribute('href', url.pathname + url.search + url.hash);
      } catch (e) {
        /* leave link unchanged */
      }
    });
  }

  function select(button) {
    var group = button.closest('[data-gs-card-swatches]');
    var cardWrapper = button.closest('.card-wrapper');
    if (!group || !cardWrapper) return;

    group.querySelectorAll('[data-gs-swatch]').forEach(function (b) {
      b.setAttribute('aria-pressed', b === button ? 'true' : 'false');
    });

    var color = button.getAttribute('data-color');
    cardWrapper.setAttribute('data-gs-selected-color', color);
    cardWrapper.classList.add('gs-swatch-selected');

    var src = button.getAttribute('data-src');
    var img = cardWrapper.querySelector('.card__media img');
    if (src && img) {
      var srcset = cleanSrcset(button.getAttribute('data-srcset'));
      if (srcset) img.setAttribute('srcset', srcset);
      img.setAttribute('src', src);
    }

    updateLinks(cardWrapper, button.getAttribute('data-variant-id'));
  }

  function expand(moreButton) {
    var group = moreButton.closest('[data-gs-card-swatches]');
    if (!group) return;
    var extras = group.querySelectorAll('.gs-card-swatches__item--extra');
    extras.forEach(function (li) {
      li.hidden = false;
    });
    moreButton.setAttribute('aria-expanded', 'true');
    var moreItem = moreButton.closest('li');
    var firstExtra = extras[0] && extras[0].querySelector('button');
    if (firstExtra) firstExtra.focus();
    if (moreItem) moreItem.hidden = true;
  }

  document.addEventListener(
    'click',
    function (event) {
      var more = event.target.closest('[data-gs-swatches-more]');
      if (more) {
        event.preventDefault();
        event.stopPropagation();
        expand(more);
        return;
      }
      var swatch = event.target.closest('[data-gs-swatch]');
      if (swatch) {
        event.preventDefault();
        event.stopPropagation();
        select(swatch);
        return;
      }
      // A tap in the gaps between swatches should do nothing (not open the product).
      if (event.target.closest('[data-gs-card-swatches]')) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  window.GSCardSwatches = { select: select };
})();
